import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import "./Forms.css";
import "./FormResponsive.css";
import "./InvoiceForm.css";
import Select from "react-select";
import { Snackbar, Alert as MuiAlert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import SubsidiaryModal from "../Popup/SubsidaryModal";
export default function ClientManagementForm({ isSidebarExpanded }) {
  const [contactPersons, setContactPersons] = useState([
    {
      id:Date.now(),
      name: "",
      email: "",
      phone: "",
      isPrimary: true,
      isFamilyPrimaryMapped: false,
    },
  ]);
  const [isSubsidiaryModalOpen, setIsSubsidiaryModalOpen] = useState(false);
  const [selectedCompanyType, setSelectedCompanyType] = useState("");
  const [clientType, setClientType] = useState("");
  const [familyGroups, setFamilyGroups] = useState([]);
  const [selectedFamilyId, setSelectedFamilyId] = useState("");
  const [familyGroupsLoading, setFamilyGroupsLoading] = useState(false);
  const [familyGroupsError, setFamilyGroupsError] = useState("");
  const [isCreateFamilyModalOpen, setIsCreateFamilyModalOpen] = useState(false);
  const [createFamilyForm, setCreateFamilyForm] = useState({
    family_name: "",
    contact_name: "",
    phone_number: "",
    email: "",
  });
  const [createFamilyErrors, setCreateFamilyErrors] = useState({});
  const [isCreatingFamily, setIsCreatingFamily] = useState(false);
  const [clientName, setClientName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [file_number, setFileNumber] = useState("");
  const [subsidaries, setSubsidaries] = useState([]);
  const [selectedSubsidary, setSelectedSubsidary] = useState("");
  const [paymentTerm, setPaymentTerm] = useState(30);
  const [selectedOptionBalance, setSelectedOptionBalance] = useState(null);
  const [dob, setDob] = useState("");
  const [pan, setPan] = useState("");
  const [openingAmount, setopeningAmount] = useState("");
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    postalCode: "",
  });
  const [errors, setErrors] = useState({
    clientName: "",
    companyName: "",
    clientType: "",
    email: "",
    phone: "",
    address: "",
    paymentTerm: "",
    pan: "",
  });
  const navigate = useNavigate(); // Initialize the useNavigate hook
  const [loading, setLoading] = useState(false); // Should be false initially
  const [isSaved, setIsSaved] = useState(false); // Should be false initially

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const companyTypes = [
    { value: "individual", label: "Individual / Proprietorship" },
    { value: "huf", label: "HUF" },
    { value: "partnership_firm", label: "Partnership Firm" },
    { value: "private_ltd", label: "Private Limited Company" },
    { value: "limited_company", label: "Limited Company" },
    { value: "llp", label: "Limited Liability Partnership" },
    { value: "aop", label: "Association of Persons" },
    { value: "trust", label: "Trust" },
  ];
  const firstfield = useRef();
  const createFamilyFirstInputRef = useRef();
  const options = [
    { value: "advance", label: "Advance" },
    { value: "pending", label: "Pending" },
    { value: "Financially Clear", label: "Financially Clear" },
  ];
  const menuPortalTarget = typeof window !== "undefined" ? document.body : null;
  const familyModalPortalTarget =
    typeof document !== "undefined" ? document.body : null;
  const isPrimaryLocked = clientType === "family group" && Boolean(selectedFamilyId);

  const getDefaultContact = () => ({
    name: "",
    email: "",
    phone: "",
    isPrimary: true,
    isFamilyPrimaryMapped: false,
  });
  const handleSubsidiaryCreated = (newSubsidiary, message) => {
    console.log("New Subsidiary Created:", newSubsidiary); // Debug log
    
  setSubsidaries((prev) => [...prev, newSubsidiary]);
  setSelectedSubsidary(newSubsidiary.value); // auto-select
  setErrors((prev) => ({ ...prev, selectedSubsidary: "" }));
  setSnackbarSeverity("success");
  setSnackbarMessage(message);
  setSnackbarOpen(true);
};
  const clearMappedFamilyContact = (contacts) => {
    const nonFamilyContacts = (contacts || [])
      .filter((contact) => !contact?.isFamilyPrimaryMapped)
      .map((contact) => ({
        ...contact,
        isFamilyPrimaryMapped: false,
      }));

    if (nonFamilyContacts.length === 0) {
      return [getDefaultContact()];
    }

    const hasPrimary = nonFamilyContacts.some((contact) => contact.isPrimary);
    return nonFamilyContacts.map((contact, index) => ({
      ...contact,
      isPrimary: hasPrimary ? contact.isPrimary : index === 0,
    }));
  };

  const handleClientTypeChange = (nextClientType) => {
    setClientType(nextClientType);
    setErrors((prev) => ({ ...prev, clientType: "" }));

    if (nextClientType !== "individual") return;

    setSelectedFamilyId("");
    setFamilyGroupsError("");
    setIsCreateFamilyModalOpen(false);
    setContactPersons((prevContacts) => clearMappedFamilyContact(prevContacts));
  };

  const handleChangeBalance = (selected) => {
    setSelectedOptionBalance(selected);
  };

  const fetchFamilyGroups = async (force = false) => {
    if (!force && (familyGroupsLoading || familyGroups.length > 0)) return;
    try {
      setFamilyGroupsLoading(true);
      setFamilyGroupsError("");
      const response = await axiosInstance.get("/api/family_group");
      const families = Array.isArray(response.data.data) ? response.data.data : [];
      setFamilyGroups(families);
    } catch (error) {
      console.error("Error fetching family groups:", error.message);
      setFamilyGroupsError("Failed to load family groups");
    } finally {
      setFamilyGroupsLoading(false);
    }
  };

  const mapFamilyContactToPrimary = (family) => {
    if (!family) return;
    setContactPersons((prevContacts) => {
      const nonFamilyContacts = (prevContacts || [])
        .filter((contact) => !contact?.isFamilyPrimaryMapped)
        .map((contact) => ({
          ...contact,
          isFamilyPrimaryMapped: false,
        }));

      const mappedFamilyPrimary = {
        name: family.contact_name || "",
        email: family.email || "",
        phone: (family.phone_number || "").toString(),
        isPrimary: true,
        isFamilyPrimaryMapped: true,
      };

      const nextContacts = [mappedFamilyPrimary, ...nonFamilyContacts];

      return nextContacts.map((contact, index) => ({
        ...contact,
        isPrimary: index === 0,
      }));
    });
  };

  const resetCreateFamilyModal = () => {
    setCreateFamilyForm({
      family_name: "",
      contact_name: "",
      phone_number: "",
      email: "",
    });
    setCreateFamilyErrors({});
    setIsCreatingFamily(false);
  };

  const openCreateFamilyModal = () => {
    document.activeElement?.blur?.();
    resetCreateFamilyModal();
    setIsCreateFamilyModalOpen(true);
  };

  const closeCreateFamilyModal = () => {
    setIsCreateFamilyModalOpen(false);
    resetCreateFamilyModal();
  };

  const validateCreateFamilyForm = () => {
    const nextErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!createFamilyForm.family_name.trim()) {
      nextErrors.family_name = "Family Name is required";
    }
    if (!createFamilyForm.contact_name.trim()) {
      nextErrors.contact_name = "Contact Name is required";
    }
    if (!createFamilyForm.phone_number.trim()) {
      nextErrors.phone_number = "Phone Number is required";
    } else if (!/^\d{10}$/.test(createFamilyForm.phone_number.trim())) {
      nextErrors.phone_number = "Phone Number must be 10 digits";
    }
    if (!createFamilyForm.email.trim()) {
      nextErrors.email = "Email Id is required";
    } else if (!emailRegex.test(createFamilyForm.email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

    setCreateFamilyErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleCreateFamily = async () => {
    if (isCreatingFamily || !validateCreateFamilyForm()) return;

    const payload = {
      family_name: createFamilyForm.family_name.trim(),
      contact_name: createFamilyForm.contact_name.trim(),
      phone_number: createFamilyForm.phone_number.trim(),
      email: createFamilyForm.email.trim(),
    };

    try {
      setIsCreatingFamily(true);
      const response = await axiosInstance.post("/api/create_family_group", payload);
      const returnedFamilyId =
        response.data?.family_id ||
        response.data?.data?.family_id ||
        response.data?.result?.family_id ||
        "";

      if (!returnedFamilyId) {
        throw new Error("Family ID missing in response");
      }

      const createdFamily = {
        family_id: returnedFamilyId,
        family_name: payload.family_name,
        contact_name: payload.contact_name,
        phone_number: payload.phone_number,
        email: payload.email,
      };

      setFamilyGroups((prev) => {
        const filtered = prev.filter(
          (family) => family.family_id !== createdFamily.family_id
        );
        return [...filtered, createdFamily];
      });

      setSelectedFamilyId(createdFamily.family_id);
      mapFamilyContactToPrimary(createdFamily);
      setSnackbarSeverity("success");
      setSnackbarMessage(response.data?.message || "Family Group added successfully");
      setSnackbarOpen(true);
      closeCreateFamilyModal();
    } catch (error) {
      console.error("Error creating family group:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to create Family Group"
      );
      setSnackbarOpen(true);
    } finally {
      setIsCreatingFamily(false);
    }
  };

  useEffect(() => {
    const fetchSubsidaries = async (status = "Active") => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/api/get_all_subsidiary?page_status=${status}`
        );

        if (response.status === 200) {
          const firms = response.data.data;
          console.log("Fetched Subsidiaries:", firms); // Debug log

          const firmNames = firms.map((company) => ({
            label: company.Subsidiary_name,
            value: company.subsidiary_id,
            tag_name: company.tag_name,
          }));

          console.log("Processed Options:", firmNames); // Debug log
          setSubsidaries(firmNames);
        } else {
          console.error("Failed to fetch subsidiaries");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subsidiary data:", error.message);
        setLoading(false);
      }
    };

    fetchSubsidaries();
  }, []);

  useEffect(() => {
    if (clientType === "family group") {
      fetchFamilyGroups();
      return;
    }

    setSelectedFamilyId("");
    setFamilyGroupsError("");
    setIsCreateFamilyModalOpen(false);
  }, [clientType]);

  useEffect(() => {
    if (isCreateFamilyModalOpen) {
      createFamilyFirstInputRef.current?.focus();
    }
  }, [isCreateFamilyModalOpen]);

  useEffect(() => {
    if (!isCreateFamilyModalOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isCreateFamilyModalOpen]);

  const handleAddContactPerson = () => {
    setContactPersons((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: "",
        email: "",
        phone: "",
        isPrimary: false,
        isFamilyPrimaryMapped: false,
      },
    ]);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...contactPersons];

    // Only allow digits & limit 10 digits in phone
    if (field === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    updated[index][field] = value;
    setContactPersons(updated);

    // Clear that specific field error
    setErrors((prev) => ({
      ...prev,
      [`${field}_${index}`]: "",
    }));
  };

  // const handleInputChange = (index, field, value) => {
  //   let next = value;
  //   // enforce digits-only + max 10 for phone
  //   if (field === "phone") {
  //     next = value.replace(/\D/g, "").slice(0, 10);
  //   }

  //   const updatedContactPersons = [...contactPersons];
  //   updatedContactPersons[index][field] = value;
  //   setContactPersons(updatedContactPersons);

  //   const hasValue =
  //     field === "phone" ? next.length === 10 : (next || "").trim().length > 0;

  //   // Clear error when user starts typing
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [`${field}_${index}`]: value.trim()
  //       ? ""
  //       : prevErrors?.[`${field}_${index}`],
  //   }));

  // };

  const handleAddressChange = (field, value) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      [field]: value,
    }));

    // Clear address error dynamically when user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      address: Object.values({ ...address, [field]: value }).every((val) =>
        val.trim()
      )
        ? ""
        : prevErrors.address,
    }));
  };

  // const validateForm = () => {
  //   const newErrors = {};
  //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  //   // Validate Contact Persons
  //   contactPersons.forEach((contact, index) => {
  //     if (!contact) {
  //       newErrors[`name_${index}`] = "Contact details are required";
  //       return;
  //     }

  //     // Validate Name
  //     if (!contact.name || !contact.name.trim()) {
  //       newErrors[`name_${index}`] = "Contact name is required";
  //     }

  //     // Validate Email
  //     if (!contact.email || !contact.email.trim()) {
  //       newErrors[`email_${index}`] = "Email is required";
  //     } else if (
  //       !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(contact.email)
  //     ) {
  //       newErrors[`email_${index}`] = "Valid email is required";
  //     }

  //     // Validate Phone Number
  //     if (!contact.phone || !contact.phone.toString().trim()) {
  //       newErrors[`phone_${index}`] = "Phone number is required";
  //     } else if (!/^[0-9]{10}$/.test(contact.phone)) {
  //       newErrors[`phone_${index}`] = "Phone number must be 10 digits";
  //     }
  //   });

  //   // Validate Client Name
  //   if (!clientName.trim()) newErrors.clientName = "Client Name is required";
  //   if (!openingAmount.trim())
  //     newErrors.openingAmount = "Opening Amount is required";

  //   // Validate Company Name
  //   if (!companyName.trim())
  //     newErrors.companyName = "Company/Firm Name is required";

  //   // Validate Company Type
  //   if (!selectedCompanyType)
  //     newErrors.selectedCompanyType = "Company Type is required";

  //   // Validate Payment Term
  //   if (!String(paymentTerm).trim())
  //     newErrors.paymentTerm = "Payment term is required";

  //   // Validate Address
  //   if (!Object.values(address).every((val) => val.trim())) {
  //     newErrors.address = "Complete address is required";
  //   }

  //   // Validate Subsidiary
  //   if (!selectedSubsidary)
  //     newErrors.selectedSubsidary = "Subsidiary selection is required";

  //   if (!pan.trim()) {
  //     newErrors.pan = "PAN number is required";
  //   } else if (!panRegex.test(pan)) {
  //     newErrors.pan = "Invalid PAN format (e.g., ABCDE1234F)";
  //   }

  //   if (!file_number || !file_number.trim()) {
  //     newErrors.file_number = "File Number is required";
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0; // Returns true if no errors exist
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;
  //   const formattedDate = dob ? dob.toISOString().split("T")[0] : null;
  //   const hasPrimary = contactPersons.some((contact) => contact.isPrimary);
  //   const today = new Date().toISOString().split("T")[0]; // Format YYYY-MM-DD

  //   const formData = {
  //     client_name: clientName,
  //     clients_company_name: companyName,
  //     file_number: file_number,
  //     company_type: selectedCompanyType || "",
  //     contacts: contactPersons.map((contact, index) => ({
  //       contact_name: contact.name,
  //       contact_email: contact.email,
  //       phone_number: contact.phone,

  //       is_primary: hasPrimary ? contact.isPrimary : index === 0, // Set the first as primary if none exist
  //     })),
  //     sub_id: selectedSubsidary, // This will be the subsidiary_id
  //     payment_terms: paymentTerm,
  //     dob: formattedDate,
  //     pan_number: pan,
  //     office_number: address.street,
  //     landmark: address.city,
  //     area: address.state,
  //     pin: address.postalCode,
  //     balance_type: selectedOptionBalance?.label,
  //     opening_balance: openingAmount,
  //     date: formattedDate || today, // Use today's date if formattedDate is not provided
  //   };

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const apiUrl = `${API_URL}/api/create_client`;
  //     const response = await axios.post(apiUrl, formData, {
  //       headers: {
  //         Authorization: `Bearer ${authKey}`,
  //       },
  //     });

  //     if (response.status === 200) {
  //       console.log("Client created successfully:", response.data);
  //       setSnackbarSeverity("success");
  //       setSnackbarMessage("Client added successfully!");
  //       setSnackbarOpen(true);

  //       // Delay navigation to show snackbar before redirecting
  //       setTimeout(() => {
  //         navigate("/client-management");
  //       }, 3000);
  //     } else {
  //       console.error("Failed to create client:", response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error.message);
  //     setSnackbarSeverity("error");
  //     setSnackbarMessage("Failed to add client. Please try again.");
  //     setSnackbarOpen(true);
  //   } finally {
  //     setLoading(false); // Reset loading state
  //   }
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm() || loading || isSaved) return; // Prevent multiple submissions

  //   setLoading(true); // Start loading state

  //   const formattedDate = dob ? dob.toISOString().split("T")[0] : null;
  //   const hasPrimary = contactPersons.some((contact) => contact.isPrimary);
  //   const today = new Date().toISOString().split("T")[0];

  //   const formData = {
  //     client_name: clientName,
  //     clients_company_name: companyName,
  //     file_number: file_number,
  //     company_type: selectedCompanyType || "",
  //     contacts: contactPersons.map((contact, index) => ({
  //       contact_name: contact.name,
  //       contact_email: contact.email,
  //       phone_number: contact.phone,
  //       is_primary: hasPrimary ? contact.isPrimary : index === 0,
  //     })),
  //     sub_id: selectedSubsidary,
  //     payment_terms: paymentTerm,
  //     dob: formattedDate,
  //     pan_number: pan,
  //     office_number: address.street,
  //     landmark: address.city,
  //     area: address.state,
  //     pin: address.postalCode,
  //     balance_type: selectedOptionBalance?.label,
  //     opening_balance: openingAmount,
  //     date: formattedDate || today,
  //   };

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const apiUrl = `${API_URL}/api/create_client`;
  //     const response = await axios.post(apiUrl, formData, {
  //       headers: {
  //         Authorization: `Bearer ${authKey}`,
  //       },
  //     });

  //     if (response.status === 200) {
  //       console.log("Client created successfully:", response.data);
  //       setSnackbarSeverity("success");
  //       setSnackbarMessage("Client added successfully!");
  //       setSnackbarOpen(true);
  //       setIsSaved(true); // Prevent further submissions

  //       // Delay navigation to show snackbar before redirecting
  //       setTimeout(() => {
  //         navigate("/client-management");
  //       }, 3000);
  //     } else {
  //       console.error("Failed to create client:", response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error.message);
  //     setSnackbarSeverity("error");
  //     setSnackbarMessage("Failed to add client. Please try again.");
  //     setSnackbarOpen(true);
  //   } finally {
  //     setLoading(false); // Stop loading state
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation check
    if (!validateForm() || loading || isSaved) return; // Prevent multiple submissions

    setLoading(true); // Start loading state

    let formattedDate = null;
    if (dob) {
      const dateRegex = /^(\d{2})-(\d{2})-(\d{4})$/;
      const match = dob.match(dateRegex);
      if (match) {
        const day = match[1];
        const month = match[2];
        const year = match[3];
        formattedDate = `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
      }
    }
    const selectedFamily =
      clientType === "family group"
        ? familyGroups.find((family) => family.family_id === selectedFamilyId)
        : null;

    if (clientType === "family group" && !selectedFamilyId) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Please select a Family Group");
      setSnackbarOpen(true);
      setLoading(false);
      return;
    }

    if (clientType === "family group" && !selectedFamily) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Selected Family Group details are not available");
      setSnackbarOpen(true);
      setLoading(false);
      return;
    }

    const nonFamilyContacts = contactPersons.filter(
      (contact) => !contact?.isFamilyPrimaryMapped
    );
    const contactsPayload =
      clientType === "family group"
        ? [
            {
              contact_name: selectedFamily?.contact_name || "",
              contact_email: selectedFamily?.email || "",
              phone_number: (selectedFamily?.phone_number || "").toString(),
              is_primary: true,
            },
            ...nonFamilyContacts.map((contact) => ({
              contact_name: contact.name,
              contact_email: contact.email,
              phone_number: contact.phone,
              is_primary: false,
            })),
          ]
        : nonFamilyContacts.map((contact, index) => ({
            contact_name: contact.name,
            contact_email: contact.email,
            phone_number: contact.phone,
            is_primary:
              nonFamilyContacts.some((entry) => entry.isPrimary)
                ? contact.isPrimary
                : index === 0,
          }));

    const formData = {
      client_name: clientName,
      clients_company_name: companyName,
      file_number: file_number,
      company_type: selectedCompanyType || "",
      contacts: contactsPayload,
      ...(clientType === "family group"
        ? {
            client_type: "family group",
            family_id: selectedFamilyId,
          }
        : {
            client_type: "individual",
          }),
      sub_id: selectedSubsidary,
      payment_terms: paymentTerm,
      dob: formattedDate,
      date: formattedDate,
      pan_number: pan,
      office_number: address.street,
      landmark: address.city,
      area: address.state,
      pin: address.postalCode,
      balance_type: selectedOptionBalance?.label,
      opening_balance: openingAmount,
    };

    try {
      const response = await axiosInstance.post("/api/create_client", formData);

      if (response.status === 200) {
        console.log("Client created successfully:", response.data);
        setSnackbarSeverity("success");
        setSnackbarMessage("Client added successfully!");
        setSnackbarOpen(true);
        setIsSaved(true); // Prevent further submissions

        // Delay navigation to show snackbar before redirecting
        setTimeout(() => {
          navigate("/client-management");
        }, 3000);
      } else {
        console.error("Failed to create client:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      // Check if the error is about duplicate PAN
      if (error.response?.data?.error === "PAN number already exists") {
        setErrors((prev) => ({
          ...prev,
          pan: "This PAN number is already registered in the system",
        }));
        setSnackbarSeverity("error");
        setSnackbarMessage("PAN number already exists in the system");
      } else {
        // Display backend error message or fallback to generic message
        const backendErrorMessage =
          error.response?.data?.error || error.response?.data?.message;

        setSnackbarSeverity("error");
        setSnackbarMessage(backendErrorMessage);
      }
      setSnackbarOpen(true);
    } finally {
      setLoading(false); // Stop loading state
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {}; // ✅ collect all errors here

    // 🔹 Validate Contact Persons
    contactPersons.forEach((contact, i) => {
      if (!contact.name?.trim()) {
        newErrors[`name_${i}`] = "Name is required";
        isValid = false;
      } else if (contact.name.length > 100) {
        newErrors[`name_${i}`] = "Name must not exceed 100 characters";
        isValid = false;
      }

      if (!contact.email?.trim()) {
        newErrors[`email_${i}`] = "Email is required";
        isValid = false;
      } else if (contact.email.length > 100) {
        newErrors[`email_${i}`] = "Email must not exceed 100 characters";
        isValid = false;
      }

      if (!contact.phone?.trim()) {
        newErrors[`phone_${i}`] = "Phone number is required";
        isValid = false;
      } else if (!/^\d{10}$/.test(contact.phone)) {
        newErrors[`phone_${i}`] = "Enter a valid 10-digit phone number";
        isValid = false;
      }
    });

    if (!selectedCompanyType) {
      newErrors.companyType = "Please select a company type";
      isValid = false;
    }

    if (!clientType) {
      newErrors.clientType = "Client Type is required";
      isValid = false;
    }

    // Birth Date Validation
    if (!dob) {
      newErrors.dob = "Birth date is required";
      isValid = false;
    } else {
      const strictRegex = /^(\d{2})-(\d{2})-(\d{4})$/;

      if (!strictRegex.test(dob)) {
        newErrors.dob = "Invalid format. Use DD-MM-YYYY";
        isValid = false;
      } else {
        const [_, dd, mm, yyyy] = dob.match(strictRegex);

        const day = parseInt(dd, 10);
        const month = parseInt(mm, 10);
        const year = parseInt(yyyy, 10);

        // Month check
        if (month < 1 || month > 12) {
          newErrors.dob = "Invalid month. Must be between 01 and 12";
          isValid = false;
        }
        // Day check
        else if (day < 1 || day > 31) {
          newErrors.dob = "Invalid day. Must be between 01 and 31";
          isValid = false;
        } else {
          const dateObj = new Date(year, month - 1, day);

          if (
            dateObj.getDate() !== day ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getFullYear() !== year
          ) {
            newErrors.dob = "Invalid date";
            isValid = false;
          }

          // ❗ Strict: Reject 1900 and below
          else if (year < 1935) {
            newErrors.dob =
              "Invalid year. Please enter a valid year (1935-2099)";
            isValid = false;
          } else {
            const today = new Date();

            // Future date
            if (dateObj > today) {
              newErrors.dob = "Birth date cannot be in the future";
              isValid = false;
            }

            // Age check (must be >= 18)
            let age = today.getFullYear() - year;
            const monthDiff = today.getMonth() - (month - 1);
            const dayDiff = today.getDate() - day;

            if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
              age--;
            }

            // if (age < 18) {
            //   newErrors.dob = "Client must be at least 18 years old";
            //   isValid = false;
            // }
          }
        }
      }
    }

    // Address Validations
    if (!address.street?.trim()) {
      newErrors.street = "Office number is required";
      isValid = false;
    } else if (address.street.length > 100) {
      newErrors.street = "Office number must not exceed 100 characters";
      isValid = false;
    }

    if (!address.city?.trim()) {
      newErrors.city = "Name of premises is required";
      isValid = false;
    } else if (address.city.length > 100) {
      newErrors.city = "Name of premises must not exceed 100 characters";
      isValid = false;
    }

    if (!address.state?.trim()) {
      newErrors.area = "Area is required";
      isValid = false;
    } else if (address.state.length > 100) {
      newErrors.area = "Area must not exceed 100 characters";
      isValid = false;
    }

    if (!address.city?.trim()) {
      newErrors.premises = "Name of premises is required";
      isValid = false;
    } else if (!/^[a-zA-Z0-9\s\-.,/&()]{2,100}$/.test(address.city)) {
      newErrors.premises = "Enter a valid premises name (2-100 characters)";
      isValid = false;
    }

    // Postal Code Validation
    if (!address.postalCode) {
      newErrors.postalCode = "Postal code is required";
      isValid = false;
    } else if (!/^\d{6}$/.test(address.postalCode)) {
      newErrors.postalCode = "Enter a valid 6-digit postal code";
      isValid = false;
    }

    // 🔹 PAN Validation
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!pan) {
      newErrors.pan = "PAN number is required";
      isValid = false;
    } else if (!panRegex.test(pan)) {
      newErrors.pan = "Invalid PAN format (e.g., ABCDE1234F)";
      isValid = false;
    } else if (pan.length > 10) {
      newErrors.pan = "PAN cannot exceed 10 characters";
      isValid = false;
    }

    // 🔹 Customer Billing Company
    if (!selectedSubsidary) {
      newErrors.selectedSubsidary = "Customer Billing Company is required";
      isValid = false;
    }

    // 🔹 Client Name
    if (!clientName?.trim()) {
      newErrors.clientName = "Client name is required";
      isValid = false;
    } else if (clientName.length > 100) {
      newErrors.clientName = "Client name must not exceed 100 characters";
      isValid = false;
    }

    // 🔹 Company Name
    if (!companyName?.trim()) {
      newErrors.companyName = "Company name is required";
      isValid = false;
    } else if (companyName.length > 150) {
      newErrors.companyName = "Company name must not exceed 150 characters";
      isValid = false;
    }

    // 🔹 Opening Amount
    if (
      selectedOptionBalance?.value !== "Financially Clear" &&
      !openingAmount
    ) {
      newErrors.openingAmount = "Opening amount is required";
      isValid = false;
    }
    if (openingAmount && Number(openingAmount) < 0) {
      newErrors.openingAmount = "Opening amount must be a positive number";
      isValid = false;
    }
    if (openingAmount && openingAmount.toString().length > 15) {
      newErrors.openingAmount = "Opening amount must not exceed 15 digits";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleCancel = () => {
    window.history.back();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleRemoveContactPerson = (index) => {
    const updatedContacts = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContacts);
  };

  const handlePrimaryChange = (selectedIndex) => {
    if (isPrimaryLocked) return;

    setContactPersons((prevContacts) =>
      prevContacts.map((contact, index) => ({
        ...contact,
        isPrimary: index === selectedIndex, // Set only the selected contact as primary
      }))
    );
  };

  const handleInputChanges = (field, value) => {
    setErrors((prev) => ({ ...prev, [field]: "" })); // Clears the specific field error
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase(); // Convert to uppercase
    setPan(value);

    // Remove error message immediately when the user starts typing
    if (errors.pan) {
      setErrors((prevErrors) => ({ ...prevErrors, pan: "" }));
    }
  };

  useEffect(() => {
    setIsSaved(false); // Reset isSaved when the form is opened
    setLoading(false); // Ensure loading is also reset
  }, []);

  useEffect(() => {
    firstfield.current.focus();
  }, []);

  return (
    <div
      className={`table-container client-management-form-page client-management-form-create ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body client-management-form-content">
        <div className="client-management-page-heading">
          <h1 className="form-title">New Client Management</h1>
          <p className="client-management-page-subtitle">
            Add client details, address information and contact persons.
          </p>
        </div>
        <div className="client-management-form-card">
          <div className="form-body-client-management client-management-form-body">
            <form className="form-box client-management-form-box">
              <div className="form-body-container client-management-form-sections">
              <section className="client-management-section">
                <div className="client-management-section-header">
                  <div>
                    <h2 className="client-management-section-title">
                      Basic Information
                    </h2>
                    <p className="client-management-section-description">
                      Add client, company and opening balance details.
                    </p>
                  </div>
                </div>

              <div className="form-group">
                <label className="form-label">
                  Client Name <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Enter Client Name"
                    ref={firstfield}
                    value={clientName || ""}
                    maxLength={100}
                    // onChange={(e) => setClientName(e.target.value)}
                    onChange={(e) => {
                      setClientName(e.target.value);
                      handleInputChanges("clientName", e.target.value);
                    }}
                    required
                  />
                  {errors.clientName && (
                    <p className="error-message">{errors.clientName}</p>
                  )}
                </div>
              </div>

              {/* Company/Firm Name */}
              <div className="form-group">
                <label className="form-label">
                  Company/Firm Name <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Enter Company/Firm Name"
                    value={companyName || ""}
                    onChange={(e) => {
                      handleInputChanges("companyName", e.target.value);
                      setCompanyName(e.target.value);
                    }} // Update state directly
                    required
                  />
                  {errors.companyName && (
                    <p className="error-message">{errors.companyName}</p>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">
                  File Number
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Enter File Number"
                    value={file_number || ""}
                    maxLength={50}
                    onChange={(e) => {
                      handleInputChanges("file_number", e.target.value);
                      setFileNumber(e.target.value);
                    }} // Update state directly
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">
                  Company Type
                  <span className="required">*</span>
                </label>
                <div className="form-inputs-companyType">
                  <Select
                    className="select-field-companyType "
                    style={{ zIndex: "99999 !important " }}
                    value={
                      selectedCompanyType
                        ? companyTypes.find(
                            (option) => option.value === selectedCompanyType
                          )
                        : null
                    }
                    onChange={(selectedOption) => {
                      const value = selectedOption ? selectedOption.value : "";
                      setSelectedCompanyType(value);
                      handleInputChanges("selectedCompanyType", value); // Clear error on selection
                    }}
                    options={companyTypes}
                    placeholder="Select Company Type"
                    isClearable
                    styles={{
                      menu: (base) => ({
                        ...base,
                        marginTop: 0,
                        borderTop: "none",
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                      }),
                      control: (base) => ({
                        ...base,
                        marginBottom: 0,
                      }),
                    }}
                  />
                </div>
                {errors.selectedCompanyType && (
                  <p className="error-message">{errors.selectedCompanyType}</p>
                )}
              </div>

              <div className="form-group">
                <label className="form-label">
                  Client Type <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <div className="radio-group">
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="client_type"
                        checked={clientType === "individual"}
                        onChange={() => handleClientTypeChange("individual")}
                      />
                      <span className="radio-text">Individual</span>
                    </label>
                    <label className="radio-label">
                      <input
                        type="radio"
                        name="client_type"
                        checked={clientType === "family group"}
                        onChange={() => handleClientTypeChange("family group")}
                      />
                      <span className="radio-text">Family Group</span>
                    </label>
                  </div>
                  {errors.clientType && (
                    <p className="error-message">{errors.clientType}</p>
                  )}
                </div>
              </div>

              {clientType === "family group" && (
                <div className="form-group">
                  <label className="form-label">Select Family Group</label>
                  <div className="form-inputs form-family-row">
                    <Select
                      className="select-field"
                      value={
                        selectedFamilyId
                          ? familyGroups
                              .map((family) => ({
                                value: family.family_id,
                                label: family.family_name,
                              }))
                              .find((option) => option.value === selectedFamilyId) ||
                            null
                          : null
                      }
                      onChange={(selectedOption) => {
                        const nextFamilyId = selectedOption?.value || "";
                        setSelectedFamilyId(nextFamilyId);

                        if (!nextFamilyId) {
                          setContactPersons((prevContacts) =>
                            clearMappedFamilyContact(prevContacts)
                          );
                          return;
                        }

                        const selectedFamily = familyGroups.find(
                          (family) => family.family_id === nextFamilyId
                        );
                        mapFamilyContactToPrimary(selectedFamily);
                      }}
                      options={familyGroups.map((family) => ({
                        value: family.family_id,
                        label: family.family_name,
                      }))}
                      placeholder={
                        familyGroupsLoading
                          ? "Loading family groups..."
                          : "Select Family Group"
                      }
                      isClearable
                      isLoading={familyGroupsLoading}
                      menuPortalTarget={menuPortalTarget}
                      menuPosition="fixed"
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                    <button
                      type="button"
                      className="family-plus-btn"
                      aria-label="Add family group"
                      onClick={openCreateFamilyModal}
                    >
                      +
                    </button>
                    {familyGroupsError && (
                      <p className="error-message">{familyGroupsError}</p>
                    )}
                  </div>
                </div>
              )}

              <div className="form-group">
                <label className="form-label">
                  Opening Balance <span className="required">*</span>
                </label>
                <Select
                  className="select-field select-field-opening-balance"
                  value={selectedOptionBalance}
                  options={options}
                  placeholder="Select advance/pending"
                  isClearable
                  onChange={handleChangeBalance}
                />
                {selectedOptionBalance &&
                  selectedOptionBalance.value !== "Financially Clear" && (
                    <input
                      type="number"
                      className="input-field input-openbalance-info"
                      placeholder="Enter Amount"
                      value={openingAmount}
                      onChange={(e) => {
                        setopeningAmount(e.target.value);
                        if (errors.openingAmount) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            openingAmount: "",
                          }));
                        }
                      }}
                    />
                  )}

                {selectedOptionBalance?.value !== "Financially Clear" &&
                  errors.openingAmount && (
                    <p className="error-message">{errors.openingAmount}</p>
                  )}
              </div>

              </section>

              <section className="client-management-section">
                <div className="client-management-section-header">
                  <div>
                    <h2 className="client-management-section-title">
                      Client Info <span className="required">*</span>
                    </h2>
                    <p className="client-management-section-description">
                      Keep incorporation or birth details and PAN information up
                      to date.
                    </p>
                  </div>
                </div>

              {/* Client Info: DOB and PAN */}
              <div className="form-group">
                <label className="form-label">
                  Client Info
                  <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <div className="date-input-container">
                    <div style={{ display: "block" }}>
                      <input
                        type="text"
                        className="input-field input-client-date birth-date"
                        placeholder="Date of Incorpoation / Date of Birth (DD-MM-YYYY)"
                        value={dob}
                        onChange={(e) => {
                          const value = e.target.value;
                          const formatted = value
                            .replace(/[^\d-]/g, "")
                            .slice(0, 10);
                          setDob(formatted);
                          setErrors((prev) => ({ ...prev, dob: "" })); // This only clears DOB error
                        }}
                        style={{ width: "90% !important" }}
                        maxLength={10}
                        required
                      />
                      {errors.dob && (
                        <p className="error-message">{errors.dob}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">
                        Date of Incorpoation / Date of Birth
                      </small>
                    </div>
                  </div>

                  <div>
                    <div>
                      <input
                        type="text"
                        className="input-field input-client-info"
                        placeholder="Enter PAN Number"
                        value={pan}
                        style={{ width: "100%" }}
                        maxLength={10}
                        onChange={handlePanChange}
                        required
                      />
                      {errors.pan && (
                        <p className="error-message">{errors.pan}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">Pan Card No.</small>
                    </div>
                  </div>
                </div>
              </div>

              </section>

              <section className="client-management-section">
                <div className="client-management-section-header">
                  <div>
                    <h2 className="client-management-section-title">
                      Client Address <span className="required">*</span>
                    </h2>
                    <p className="client-management-section-description">
                      Arrange the full office address in a cleaner layout.
                    </p>
                  </div>
                </div>

              {/* Address Fields */}
              <div className="form-group">
                <label className="form-label">
                  Client Address
                  <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  {/* First row of inputs */}
                  <div className="address-row" style={{ width: "24%" }}>
                    <div>
                      <input
                        type="text"
                        className="input-field input-client-info"
                        placeholder="Enter office number"
                        maxLength={100}
                        value={address.street}
                        style={{ width: "100% !important" }}
                        onChange={(e) => {
                          handleAddressChange("street", e.target.value);
                          setErrors((prev) => ({ ...prev, street: "" }));
                        }}
                        required
                      />
                      {errors.street && (
                        <p className="error-message">{errors.street}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">Office Number</small>
                    </div>
                  </div>
                  <div
                    className="address-row"
                    style={{ width: "24% !important" }}
                  >
                    <div>
                      <input
                        type="text"
                        className="input-field input-premise-info"
                        placeholder="Name of premises"
                        value={address.city}
                        style={{ width: "110% !important" }}
                        maxLength={100}
                        onChange={(e) => {
                          handleAddressChange("city", e.target.value);
                          setErrors((prev) => ({ ...prev, city: "" }));
                        }}
                        required
                      />
                      {errors.premises && (
                        <p className="error-message">{errors.premises}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">
                        Name of premises
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label"></label>
                <div
                  className="form-inputs-clinetAdress"
                  style={{ gap: "22px", width: "37%" }}
                >
                  <div
                    className="address-rowss"
                    id="vishal1"
                    style={{ width: "50%" }}
                  >
                    <div>
                      <input
                        type="text"
                        className="input-field input-adress-info"
                        placeholder="Area"
                        maxLength={100}
                        value={address.state}
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          handleAddressChange("state", e.target.value);
                          setErrors((prev) => ({ ...prev, area: "" }));
                        }}
                        required
                      />
                      {errors.area && (
                        <p className="error-message">{errors.area}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">Area</small>
                    </div>
                  </div>
                  <div
                    className="address-rowss"
                    id="vishal2"
                    style={{ width: "50%" }}
                  >
                    <div>
                      <input
                        type="number"
                        className="input-field input input-adress-info"
                        placeholder="Postal code"
                        value={address.postalCode}
                        onChange={(e) => {
                          const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 6);
                          handleAddressChange("postalCode", value);
                          setErrors((prev) => ({ ...prev, postalCode: "" }));
                        }}
                        required
                      />
                      {errors.postalCode && (
                        <p className="error-message">{errors.postalCode}</p>
                      )}
                    </div>
                    <div>
                      <small className="date-format-hint">Postal code</small>
                    </div>
                  </div>
                </div>
                {/* Show PAN error */}
              </div>

              </section>

              <section className="client-management-section">
                <div className="client-management-section-header">
                  <div>
                    <h2 className="client-management-section-title">
                      Contact Person Details <span className="required">*</span>
                    </h2>
                    <p className="client-management-section-description">
                      Manage primary and additional contact persons.
                    </p>
                  </div>
                </div>

              <div className="form-group client-management-contact-section-group">
                <label className="form-label">
                  Contact Person Details <span className="required">*</span>
                </label>

                <div className="form-inputs">
                  {contactPersons.map((contact, index) => (
                    <div key={contact.id} className="contact-person-fields">
                      <div className="contact-detail">
                        <div>
                          <input
                            type="text"
                            className="input-field"
                            placeholder="Enter Contact Person Name"
                            maxLength={100}
                            style={{}}
                            value={contact.name || ""}
                            readOnly={
                              isPrimaryLocked && Boolean(contact.isFamilyPrimaryMapped)
                            }
                            onChange={(e) =>
                              handleInputChange(index, "name", e.target.value)
                            }
                            required
                          />
                          {errors[`name_${index}`] && (
                            <span className="error-message">
                              {errors[`name_${index}`]}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="contact-detail">
                        <input
                          type="email"
                          className="input-field"
                          placeholder="Enter Contact Person Email"
                          maxLength={100}
                          value={contact.email || ""}
                          readOnly={
                            isPrimaryLocked && Boolean(contact.isFamilyPrimaryMapped)
                          }
                          onChange={(e) =>
                            handleInputChange(index, "email", e.target.value)
                          }
                          required
                        />
                        {errors[`email_${index}`] && (
                          <span className="error-message">
                            {errors[`email_${index}`]}
                          </span>
                        )}
                      </div>

                      <div className="contact-detail">
                        <div className="test">
                          <input
                            type="text"
                            className="input-field"
                            placeholder="Enter Phone Number"
                            value={contact.phone || ""}
                            maxLength={10}
                            inputMode="numeric"
                            readOnly={
                              isPrimaryLocked && Boolean(contact.isFamilyPrimaryMapped)
                            }
                            onChange={(e) =>
                              handleInputChange(index, "phone", e.target.value)
                            }
                            required
                          />
                          {errors[`phone_${index}`] && (
                            <span className="error-message">
                              {errors[`phone_${index}`]}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="contact-detail primary-contact">
                        <label className="radio-label">
                          Set as Primary Contact?
                        </label>
                        <div className="radio-options">
                          <label className="radio-option">
                            <input
                              type="radio"
                              name={`primaryContact_${index}`}
                              checked={contact.isPrimary}
                              disabled={isPrimaryLocked}
                              onChange={() => handlePrimaryChange(index)}
                            />
                          </label>
                        </div>
                      </div>

                      {contactPersons.length > 1 && (
                        <div className="button-field cancel-btn-client">
                          <button
                            type="button"
                            className="remove-contact-btn"
                            onClick={() => handleRemoveContactPerson(index)}
                          >
                            <span>×</span>
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                  <div className="add-contact-btn-wrapper">
                    <button
                      type="button"
                      className="add-contact-btn"
                      onClick={handleAddContactPerson}
                    >
                      <span>+</span>
                      <span className="add-text">Add More Contact Person</span>
                    </button>
                  </div>
                </div>
              </div>

              </section>

              <section className="client-management-section client-management-section-last">
                <div className="client-management-section-header">
                  <div>
                    <h2 className="client-management-section-title">
                      Billing & Terms
                    </h2>
                    <p className="client-management-section-description">
                      Keep billing company and payment terms aligned with the
                      client record.
                    </p>
                  </div>
                </div>

              <div className="form-group">
                <label className="form-label">
                  Customer Billing Company <br />
                  (Subsidiary)
                  <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <Select
                    className={`select-field ${
                      errors.selectedSubsidary ? "input-error" : ""
                    }`}
                    value={
                      selectedSubsidary
                        ? subsidaries.find(
                            (sub) => sub.value === selectedSubsidary
                          )
                        : null
                    }
                    onChange={(selectedOption) => {
                      const selectedId = selectedOption
                        ? selectedOption.value
                        : null;

                      console.log("Selected Subsidiary ID:", selectedId); // Log the selected subsidiary ID
                      console.log("Selected Subsidiary:", selectedOption); // Log the full selected option

                      setSelectedSubsidary(selectedId); // Update the state with selected subsidiary ID

                      // Clear error when a valid subsidiary is selected
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        selectedSubsidary: selectedId
                          ? ""
                          : prevErrors?.selectedSubsidary,
                      }));
                    }}
                    options={subsidaries.map((sub) => ({
                      value: sub.value, // Using subsidiary_id for value
                      label: `${sub.label} (${sub.tag_name})`, // Display name and tag
                    }))}
                    placeholder="Select Type Of Client"
                    isClearable
                    styles={{
                      menu: (base) => ({
                        ...base,
                        marginTop: 0,
                        borderRadius: 6,
                        zIndex: 1000, // Ensure dropdown is above other elements
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px", // Set a max height for better scrolling
                        overflowY: "auto",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: "40px", // Increase height for better appearance
                        borderColor: "#ccc",
                      }),
                    }}
                  />
                  <button
                      type="button"
                      className="family-plus-btn"
                      aria-label="Add family group"
                     onClick={() => setIsSubsidiaryModalOpen(true)}
                    >
                      +
                    </button>
                  {errors.selectedSubsidary && (
                    <span className="error-message">
                      {errors.selectedSubsidary}
                    </span>
                  )}
                </div>
              </div>

              {/* Payment Term */}
              <div className="form-group">
                <label className="form-label">
                  Payment Terms
                  <span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Enter Payment Terms"
                    value={paymentTerm}
                    onChange={(e) => setPaymentTerm(e.target.value)}
                    required
                  />
                  <p className="payment-days">Days</p>
                  {errors.paymentTerm && (
                    <p className="error-message">{errors.paymentTerm}</p>
                  )}
                </div>
              </div>
              </section>
            </div>
          </form>
          </div>
          <div className="form-footer client-management-form-footer">
        <div className="button-group">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={handleCancel}
            disabled={loading} // Disable if loading
          >
            CANCEL
          </button>
          <button
            type="submit"
            className="btn btn-save"
            onClick={handleSubmit}
            disabled={loading || isSaved} // Disable if saving or already saved
          >
            SAVE
          </button>
        </div>
      </div>
        </div>
      </div>

      {isCreateFamilyModalOpen &&
        familyModalPortalTarget &&
        createPortal(
          <div className="invoice-family-modal-root">
            <div className="invoice-family-modal-overlay" />
            <div className="invoice-family-modal-wrapper">
              <div className="invoice-family-modal-content">
                <div className="invoice-family-modal-header">
                  <div>
                    <h2 className="invoice-family-modal-title">Create New Family Group</h2>
                    <p className="invoice-family-modal-subtitle">
                      Add a family group to associate with this client.
                    </p>
                  </div>
                  <button
                    type="button"
                    className="invoice-family-modal-close"
                    onClick={closeCreateFamilyModal}
                    aria-label="Close family group modal"
                  >
                    <X size={18} />
                  </button>
                </div>
                <div className="invoice-family-modal-body">
                  <div className="invoice-family-form-stack">
                    <div className="client-form-group">
                      <label className="client-form-label">
                        Family Name <span className="client-required">*</span>
                      </label>
                      <input
                        ref={createFamilyFirstInputRef}
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.family_name ? "client-input-error" : ""
                        }`}
                        autoFocus
                        placeholder="Enter Family Name"
                        value={createFamilyForm.family_name}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            family_name: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            family_name: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.family_name && (
                        <p className="client-error-message">
                          {createFamilyErrors.family_name}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Contact Name <span className="client-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.contact_name ? "client-input-error" : ""
                        }`}
                        placeholder="Enter Contact Name"
                        value={createFamilyForm.contact_name}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            contact_name: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            contact_name: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.contact_name && (
                        <p className="client-error-message">
                          {createFamilyErrors.contact_name}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Phone Number <span className="client-required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.phone_number ? "client-input-error" : ""
                        }`}
                        placeholder="Enter Phone Number"
                        value={createFamilyForm.phone_number}
                        maxLength={10}
                        onChange={(e) => {
                          const phoneValue = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 10);
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            phone_number: phoneValue,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            phone_number: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.phone_number && (
                        <p className="client-error-message">
                          {createFamilyErrors.phone_number}
                        </p>
                      )}
                    </div>

                    <div className="client-form-group">
                      <label className="client-form-label">
                        Email Id <span className="client-required">*</span>
                      </label>
                      <input
                        type="email"
                        className={`invoice-family-input-field ${
                          createFamilyErrors.email ? "client-input-error" : ""
                        }`}
                        placeholder="Enter Email Id"
                        value={createFamilyForm.email}
                        onChange={(e) => {
                          setCreateFamilyForm((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                          setCreateFamilyErrors((prev) => ({
                            ...prev,
                            email: "",
                          }));
                        }}
                      />
                      {createFamilyErrors.email && (
                        <p className="client-error-message">
                          {createFamilyErrors.email}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="invoice-family-modal-buttons">
                  <button
                    type="button"
                    className="invoice-client-secondary-btn"
                    onClick={closeCreateFamilyModal}
                    disabled={isCreatingFamily}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="invoice-client-primary-btn"
                    onClick={handleCreateFamily}
                    disabled={isCreatingFamily}
                  >
                    {isCreatingFamily ? "Creating..." : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>,
          familyModalPortalTarget
        )}
    <SubsidiaryModal
  isOpen={isSubsidiaryModalOpen}
  onClose={() => setIsSubsidiaryModalOpen(false)}
  onSuccess={handleSubsidiaryCreated}
/>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(40px)", marginLeft: "15px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
